/* eslint-disable import/no-mutable-exports,
    no-unneeded-ternary */

import { getUrlQuery } from './urlParamsUtils';

export let isNetbankCustomer: boolean;
export const initCustomer = () => {
  isNetbankCustomer = getUrlQuery('ct') === '1' ? true : false;
};

export default isNetbankCustomer;
